module.exports = __webpack_public_path__ + "img/ZB52_02.118f556d.jpg";